// Last settled value of the `mainnet_enabled` gate (DevToolkit override or
// Statsig), written by `<MainnetGateMirror />`. `null` until the gate first
// settles. It holds through Statsig loading and identity updates, so the
// active network changes only when the gate itself does.

'use client';

import type { StoreApi, UseBoundStore } from 'zustand';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

export interface SettledMainnetGateState {
  settled: boolean | null;
}

export const useSettledMainnetGateStore: UseBoundStore<StoreApi<SettledMainnetGateState>> =
  createTrackedStore<SettledMainnetGateState>('useSettledMainnetGateStore')(() => ({
    settled: null,
  }));
